import React, { useEffect } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Alerts from './pages/Alerts/Alerts';
import Home from './pages/Home/Home';
import Programs from './pages/Programs/Programs';
import Progress from './pages/Progress/Progress';
import Users from './pages/Users/Users';
import SensorData from './pages/SensorData/SensorData';
import TableData from './pages/Questionnaire/TableData';
import EducationList from './pages/Programs/Education/EducationList';
import ExerciseList from './pages/Programs/Exercise/ExerciseList';
import InstructionList from './pages/Programs/Instructions/InstructionList';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import Forgotpassword from './pages/Forgotpassword/Forgotpassword';
import UserDashboard from './pages/UserDashboard/UserDashboard';
import PreLogin from './pages/Login/PreLogin';
import Profile from './pages/Profile/Profile';
import UserDetails from './pages/UserDetails/UserDetails';
import ExercisePage from './pages/UserDashboard/Exercise/ExercisePage';
import UserEducationPage from './pages/UserDashboard/Education/EducationPage';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from './redux/slices/authSlice';
import useIdleTimer from './components/UseIdleTimer';

const userInfo = JSON.parse(localStorage.getItem('userInfo'));

function App() {

  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);


  useIdleTimer(() => {
    if (isAuthenticated) {
      dispatch(logoutUser());
      // alert("You have been logged out due to inactivity.");
      reloadFunction();
    }
  }, 10 * 60 * 1000); // 10 minutes

  const reloadFunction = () => {
    localStorage.setItem('isValueExp', true);
    window.location.reload();
  }

  // alert("You have been logged out due to inactivity.");

  return (
    <Router>
      <Routes>
        <Route path="/prelogin" element={<PreLogin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgotpassword" element={<Forgotpassword />} />

        <Route path="/" element={<Layout />}>
          <Route
            index
            element={
              userInfo ? (
                userInfo.userType === 'user' ? (
                  <UserDashboard />
                ) : (
                  <Home />
                )
              ) : (
                <PreLogin />
              )
            }
          />
          <Route path="/home" element={<Home />} />
          <Route path="/users" element={<Users />} />
          <Route path="/user_details/:userId" element={<UserDetails />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/sensordata/:userId" element={<SensorData />} />
          <Route path="/questionnaire/:userId" element={<TableData />} />
          <Route path="/educationList" element={<EducationList />} />
          <Route path="/exerciseList" element={<ExerciseList />} />
          <Route path="/instructionList" element={<InstructionList />} />
          <Route path="/userdashboard" element={<UserDashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/exercise" element={<ExercisePage />} />
          <Route path="/education" element={<UserEducationPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;


// import React from 'react';
// import { Router } from 'react-router';
// import AppRouter from './router';
// import { browserHistory } from 'react-router';

// function App() {
//   return (
//     <Router history={browserHistory}>
//       <AppRouter />
//     </Router>
//   );
// }

// export default App;
